module.exports = __webpack_public_path__ + "img/portfolio-grid-layout.b5e7afc4.png";